module.exports = __webpack_public_path__ + "img/darkrose.4b95b938.png";